<form #form="ngForm">
  <h1 anessaTranslation="PROJECT.PLANT_SPEC.TITLE"></h1>

  <!-- Plant Specification Selects -->
  <div class="row border-outline" id="specifications">
    <div [ngClass]="getDropdownWidthClass()">
      <h4 anessaTranslation="PROJECT.PLANT_SPEC.DIGESTER_TYPE"></h4>
      <div
        (mouseenter)="showClearSelectedDigester = true"
        (mouseleave)="showClearSelectedDigester = false"
        class="edit-inline-row form-field-container">
        <mat-form-field floatLabel="never">
          <mat-select
            disableOptionCentering
            name="digesterSelect"
            placeholder="{{ 'PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger }}"
            [(ngModel)]="plantSpec.selectedDigester"
            (selectionChange)="onDigesterChange()">
            <mat-option
              *ngFor="let digester of digesterTypes"
              [value]="digester">
              {{ digester | anessaTranslation: trigger }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <p
          *ngIf="plantSpec.selectedDigester && showClearSelectedDigester"
          class="form-field-clear"
          (click)="clearInput('selectedDigester')">
          {{ 'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger }}
        </p>
      </div>
    </div>
    <div [ngClass]="getDropdownWidthClass()">
      <h4 anessaTranslation="PROJECT.PLANT_SPEC.PLANT_UNIT"></h4>
      <div
        (mouseenter)="showClearSelectedUnits = true"
        (mouseleave)="showClearSelectedUnits = false"
        class="edit-inline-row form-field-container">
        <mat-form-field floatLabel="never">
          <mat-select
            disableOptionCentering
            multiple
            name="unitSelect"
            placeholder="{{ 'PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger }}"
            [(ngModel)]="plantSpec.selectedUnits">
            <mat-select-trigger>{{ getUnitsDisplay() }}</mat-select-trigger>
            <mat-option
              #opt
              *ngFor="let unit of plantUnits"
              [value]="unit"
              [disabled]="!canSelectUnit(unit)"
              (click)="updateUnits(unit, opt)">
              {{ plantUnitProducts[unit] }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <p
          *ngIf="plantSpec.selectedUnits && plantSpec.selectedUnits.length > 0 && showClearSelectedUnits"
          class="form-field-clear"
          (click)="clearInput('selectedUnits')">
          {{ 'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger }}
        </p>
      </div>
    </div>
    <div *ngIf="hasPlantUnit(PlantUnitType.DEWATERING)" class="col-3">
      <h4 anessaTranslation="PROJECT.PLANT_SPEC.DEWATERING_TYPE"></h4>
      <div
        (mouseenter)="showClearDewateringType = true"
        (mouseleave)="showClearDewateringType = false"
        class="edit-inline-row form-field-container">
        <mat-form-field floatLabel="never">
          <mat-select
            disableOptionCentering
            name="dewateringType"
            placeholder="{{ 'PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger }}"
            [(ngModel)]="plantSpec.dewateringType"
            (ngModelChange)="updateDewateringAssumptions()">
            <mat-option [value]="'PROJECT.PLANT_SPEC.CENTRIFUGE'">
              {{ 'PROJECT.PLANT_SPEC.CENTRIFUGE' | anessaTranslation: trigger }}
            </mat-option>
            <mat-option [value]="'PROJECT.PLANT_SPEC.SCREW_PRESS'">
              {{ 'PROJECT.PLANT_SPEC.SCREW_PRESS' | anessaTranslation: trigger }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <p
          *ngIf="plantSpec.dewateringType && showClearDewateringType"
          class="form-field-clear"
          (click)="clearInput('dewateringType')">
          {{ 'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger }}
        </p>
      </div>
    </div>
  </div>

  <!-- Biogas Share Spec -->
  <div class="flex-container" *ngIf="hasMultipleGasUnits()">
    <div class="relative-container border-outline" style="width: 100%;">
      <h3 class="outline-border-header" anessaTranslation="PROJECT.PLANT_SPEC.BIOGAS_SHARE"></h3>
      <div style="padding: 0 20px;">
        <app-percent-slider
          [sliderData]="sliderData"
          (sliderDataChange)="sliderChange()">
        </app-percent-slider>
      </div>
    </div>
  </div>

  <!-- Generated Products -->
  <div *ngIf="plantSpec.selectedDigester && plantSpec.selectedUnits.length > 0">
    <div class="flex-container">
      <div class="relative-container border-outline col-1">
        <h3 class="outline-border-header" anessaTranslation="PROJECT.PLANT_SPEC.GEN_PROD"></h3>
        <div class="flex-container" style="align-items: center;">
          <anessa-table
            [data]="generatedProducts"
            [keys]="['name']"
            [editType]="'external'"
            [style]="'small'"
            [multiColumn]="true"
            (onEdit)="editProductClick($event)"
            (onRemove)="removeProductClick($event)">
          </anessa-table>
        </div>
      </div>
    </div>
  </div>
</form>
